const init = () => {
    $(".ns-cards-carousel").each(function () {
        const $this = $(this);
        const $container = $this.find(".ns-cards-carousel__container");
        const $navigationPrev = $this.find(".ns-cards-carousel__prev");
        const $navigationNext = $this.find(".ns-cards-carousel__next");
        const speed = 800;
        let transitionTimeout = null;
        let isTransitionActive = false;

        $container.owlCarousel({
            center: true,
            loop: true,
            autoWidth: true,
            nav: false,
            dots: false,
            margin: 16,
            smartSpeed: speed,
        });

        const setTransitionTimeout = (/* $items */) => {
            transitionTimeout = setTimeout(() => {
                /* $items
                    .removeClass("ns-cards-carousel__item--move-left")
                    .removeClass("ns-cards-carousel__item--move-right"); */

                isTransitionActive = false;

                clearTimeout(transitionTimeout);
            }, speed - 280);
        };

        $navigationPrev.on("click", () => {
            if (isTransitionActive === true) {
                return;
            }

            isTransitionActive = true;

            $container.trigger("prev.owl.carousel");

            /* const $items = $this.find(".ns-cards-carousel__item");

            $items.addClass("ns-cards-carousel__item--move-right"); */

            setTransitionTimeout(/* $items */);
        });

        $navigationNext.on("click", () => {
            if (isTransitionActive === true) {
                return;
            }

            isTransitionActive = true;

            $container.trigger("next.owl.carousel");

            /* const $items = $this.find(".ns-cards-carousel__item");

            $items.addClass("ns-cards-carousel__item--move-left"); */

            setTransitionTimeout(/* $items */);
        });
    });
};

window.addEventListener("DOMContentLoaded", init, false);
